import { render, staticRenderFns } from "./DailyStats.vue?vue&type=template&id=8e23fd9e&scoped=true&"
import script from "./DailyStats.vue?vue&type=script&lang=js&"
export * from "./DailyStats.vue?vue&type=script&lang=js&"
import style0 from "./DailyStats.vue?vue&type=style&index=0&id=8e23fd9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e23fd9e",
  null
  
)

export default component.exports